import axios from 'axios';

export let config = {
  apiUrl: 'https://plus-dev-api.smartermeasure.com/v1',
  apiHealth: 'https://plus-dev-api.smartermeasure.com/',
  spApiUrl: 'https://api.dev.smarterproctoring.com/v1',
  lhApiUrl: 'https://signon-stage.smarterservices.com/v1',
  logRocket: 'uo1ikv/smartermeasure',
  gereSid: 'AI2f435bb8690c4df5b409ac27e3aac1d4',
  posthogApiKey: 'phc_suk8Oz36V7K2J9Ln0cXXgF7Cl1edYmjmffAz3Y5SDVc',
  posthogHost: 'https://app.posthog.com',
  customRedirectInstalls: [
    'AI0e45ec9b3d8c47db98313b10590c8bdb',
    'AI7ca9323c531043e39b3aab09a2dfb11f',
    'AIfd3c4691a7dc4c16b72375e7ba1ff8b1'
  ],
  provisionInstall: 'AI0e45ec9b3d8c47db98313b10590c8bdb',
  adobeScriptSrc: '//assets.adobedtm.com/4ceff8eaacd1/61a75501f0b7/launch-70903f186ff3.min.js',
  compassToolAdobeScriptSrc: 'https://assets.adobedtm.com/4ceff8eaacd1/48a9f166f540/launch-d13cb643e0bf-development.min.js'
};

// Flag local development
if (!process.env.REACT_APP_ENVIRONMENT) {
  sessionStorage.setItem('local', true);
}

// QA
if (process.env.REACT_APP_ENVIRONMENT === 'qa') {
  config.apiUrl = 'https://plus.api.stage.smartermeasure.com/v1';
  config.spApiUrl = 'https://api.smarterproctoring.com/v1';
  config.lhApiUrl = 'https://signon.smarterservices.com/v1';
  config.webhookUrl = 'wss://271a8hzhk6.execute-api.us-east-1.amazonaws.com/stage/';
  config.provisionInstall = 'AI7ca9323c531043e39b3aab09a2dfb11f';
}
// Production
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  config.apiUrl = 'https://plus.api.smartermeasure.com/v1';
  config.spApiUrl = 'https://api.smarterproctoring.com/v1';
  config.lhApiUrl = 'https://signon.smarterservices.com/v1';
  config.posthogApiKey = 'phc_AdTlBK0Gsh77tMkF8J0wTBruU6dCz9zeBWjuANMToZW';
  config.compassToolAdobeScriptSrc = 'https://assets.adobedtm.com/4ceff8eaacd1/48a9f166f540/launch-50d3fc748802.min.js';
  config.provisionInstall = 'AIfd3c4691a7dc4c16b72375e7ba1ff8b1';
}

// Set up API bases
export let api = axios.create({
  baseURL: config.apiUrl
});

export let apiHealth = axios.create({
  baseUrl: config.apiHealth
});

export let spApi = axios.create({
  baseURL: config.spApiUrl
});

export let lhApi = axios.create({
  baseURL: config.lhApiUrl
});

// Add token to API base headers
export function setToken(token) {
  api = axios.create({
    baseURL: config.apiUrl,
    headers: { token }
  });

  apiHealth = axios.create({
    baseURL: config.apiUrl,
    headers: { token }
  });

  spApi = axios.create({
    baseURL: config.spApiUrl,
    headers: { token }
  });

  lhApi = axios.create({
    baseURL: config.lhApiUrl,
    headers: { token }
  });
}
